import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import Dotdotdot from 'react-dotdotdot';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { useBreakpoint, useMatchBreakpoint } from "../../../theme/src";
import { Title } from './Title';
import { getControlsWidth } from '../utils/getControlsWidth';
const DESCRIPTION_CLAMP = {
    l: 4,
    m: 7,
    s: 8,
    xl: 6,
};
const Controls = ({ contentHeight, filteredControls, isBreakpointMobile, }) => {
    const containerRef = useRef(null);
    const [areButtonsVerticallyAlign, setAreButtonsVerticallyAlign] = useState(false);
    useLayoutEffect(() => {
        if (containerRef.current) {
            const containerWidth = containerRef.current.offsetWidth;
            const buttonsWidths = Array.from(containerRef.current.children).map((button) => button.offsetWidth);
            getControlsWidth({
                buttonsWidths,
                containerWidth,
                isBreakpointMobile,
                setAreButtonsVerticallyAlign,
            });
        }
    }, [filteredControls, isBreakpointMobile, contentHeight]);
    if (!filteredControls.length) {
        return null;
    }
    return (_jsx(ButtonsContainer, { "$areButtonsVerticallyAlign": areButtonsVerticallyAlign, ref: containerRef, children: filteredControls.map((control, index) => (_jsx(ButtonWrapper, { "$areButtonsVerticallyAlign": areButtonsVerticallyAlign, "$isBreakpointMobile": isBreakpointMobile, children: control }, index))) }));
};
export const Content = ({ contentHeight, description, filteredControls, maxWidthContent, showControls, showDescription, showPicture, title, widthContent, }) => {
    const breakpoint = useBreakpoint();
    const isBreakpointMobile = useMatchBreakpoint('s');
    const descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split('\n');
    return (_jsx(ContentBox, { "$isBreakpointMobile": isBreakpointMobile, "$showPicture": showPicture, dataTestId: "appheader-content", height: contentHeight, children: _jsxs(Box, { flexDirection: "column", maxWidth: maxWidthContent, width: widthContent, children: [_jsx(Title, { title: title }), showDescription && (_jsx(Box, { font: "h4-regular", mt: "6px", title: description, children: _jsx(Dotdotdot, { clamp: DESCRIPTION_CLAMP[breakpoint], useNativeClamp: true, children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map((paragraph, index) => (_jsx(DescriptionParagraph, { children: paragraph || '\u00A0' }, index))) }) })), showControls && (_jsx(Controls, { contentHeight: contentHeight, filteredControls: filteredControls, isBreakpointMobile: isBreakpointMobile }))] }) }));
};
const ContentBox = styled(Box).attrs(({ $isBreakpointMobile, $showPicture }) => ({
    flexDirection: 'column',
    height: {
        l: 'auto',
    },
    justifyContent: {
        m: 'center',
    },
    px: $isBreakpointMobile && $showPicture ? 4 : 0,
    py: $isBreakpointMobile && $showPicture ? 6 : 0,
    width: $showPicture
        ? {
            l: 468,
            s: '100%',
            xl: '100%',
        }
        : undefined,
})) ``;
const DescriptionParagraph = styled.p `
  margin: 0;
`;
const ButtonsContainer = styled(Box).attrs(({ $areButtonsVerticallyAlign }) => ({
    display: 'flex',
    flexWrap: $areButtonsVerticallyAlign ? 'wrap' : 'nowrap',
    gap: 4,
    mt: 4,
})) ``;
const ButtonWrapper = styled(Box).attrs(({ $areButtonsVerticallyAlign, $isBreakpointMobile }) => ({
    mr: $areButtonsVerticallyAlign ? 0 : 3,
    width: $isBreakpointMobile ? '100%' : 'inherit',
})) `
  & button {
    width: ${({ $isBreakpointMobile }) => $isBreakpointMobile ? '100%' : 'auto'};
  }

  &:last-child {
    margin-right: 0;
    margin-top: ${({ $areButtonsVerticallyAlign }) => $areButtonsVerticallyAlign ? '12px' : 0};
  }
`;
//# sourceMappingURL=Content.js.map